module.exports = __webpack_public_path__ + "img/e2e54ab67880a6624aeb1c8e9f637b6a.0e88b41d.png";